document.addEventListener('DOMContentLoaded', ()=> {
  class QuantitySelector extends HTMLElement {
    constructor() {
      super();
      this.cacheElements();
      this.bindEvents()
    }

    cacheElements(){
      this.minusBtn = this.querySelector('[data-action="minus"]')
      this.plusBtn = this.querySelector('[data-action="plus"]')
      this.input = this.querySelector('input')
    }

    bindEvents() {
      if (!this.minusBtn || !this.plusBtn || !this.input) return;

      this.minusBtn.addEventListener('click', this.onMinus)
      this.plusBtn.addEventListener('click', this.onPlus)
    }

    onMinus = (e) => {
      e.preventDefault();
      if(this.input.value > 1) {
        --this.input.value 
      }
    }

    onPlus = (e) => {
      e.preventDefault();
      ++this.input.value 
    }
  }
  customElements.define('quantity-selector', QuantitySelector)
})